import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Reactive index of which tools have a restorable pre-apply snapshot.
 *
 * The snapshots themselves (BufferGeometry) live in `undoSnapshot.js` outside
 * Zustand, same as the step mesh pool — only the availability flags belong in
 * state, because the Undo button's enabled/disabled look has to re-render when
 * a snapshot appears or is consumed.
 */
const useUndoSnapshotStore = create(
  devtools((set, get) => ({
    /** @type {Record<string, true>} */
    availableByTool: {},

    hasSnapshot: (toolId) => !!toolId && !!get().availableByTool[toolId],

    markAvailable: (toolId) =>
      set((state) =>
        state.availableByTool[toolId]
          ? state
          : { availableByTool: { ...state.availableByTool, [toolId]: true } },
      ),

    markUnavailable: (toolId) =>
      set((state) => {
        if (!state.availableByTool[toolId]) return state;
        const { [toolId]: _dropped, ...rest } = state.availableByTool;
        return { availableByTool: rest };
      }),

    /** Replace the whole index (pool hydrate / clear-all). */
    setAvailable: (toolIds) =>
      set({
        availableByTool: (toolIds ?? []).reduce((acc, id) => {
          acc[id] = true;
          return acc;
        }, {}),
      }),

    clearAll: () => set({ availableByTool: {} }),
  })),
);

export default useUndoSnapshotStore;
